import { convertDateFromTimeZoneAgnostic, getBrowserLanguage } from "./Support";

export enum DateFormat {
    Short = "short",
    Medium = "medium",
    Long = "long",
    WeekdayOnly = "weekday-only",
}

export enum TimeFormat {
    WithoutSeconds = "without-seconds",
    WithSeconds = "with-seconds",
}

// We ##cacheFormatting.
let lastDateFormat: DateFormat | undefined;
let lastTimeFormat: TimeFormat | undefined;
let lastFormatter: Intl.DateTimeFormat | undefined;

export function makeDateTimeFormat(
    dateFormat: DateFormat | undefined,
    timeFormat: TimeFormat | undefined
): Intl.DateTimeFormat {
    if (lastFormatter !== undefined && dateFormat === lastDateFormat && timeFormat === lastTimeFormat) {
        return lastFormatter;
    }

    let options: Intl.DateTimeFormatOptions;
    if (dateFormat === DateFormat.Short) {
        options = { day: "numeric", month: "numeric", year: "numeric" };
    } else if (dateFormat === DateFormat.Medium) {
        options = { day: "numeric", month: "long", year: "numeric" };
    } else if (dateFormat === DateFormat.Long) {
        options = { weekday: "long", day: "numeric", month: "long", year: "numeric" };
    } else if (dateFormat === DateFormat.WeekdayOnly) {
        options = { weekday: "long" };
    } else {
        options = {};
    }

    if (timeFormat === TimeFormat.WithoutSeconds) {
        options = { ...options, hour: "numeric", minute: "2-digit" };
    } else if (timeFormat === TimeFormat.WithSeconds) {
        options = { ...options, hour: "numeric", minute: "2-digit", second: "2-digit" };
    }

    lastDateFormat = dateFormat;
    lastTimeFormat = timeFormat;
    lastFormatter = new Intl.DateTimeFormat(getBrowserLanguage(), options);

    return lastFormatter;
}

export function formatDateTime(
    dateTZA: Date,
    dateFormat: DateFormat | undefined,
    timeFormat: TimeFormat | undefined
): string | undefined {
    if (isNaN(dateTZA as any)) return undefined;
    return makeDateTimeFormat(dateFormat, timeFormat).format(convertDateFromTimeZoneAgnostic(dateTZA));
}
